import { useState } from 'react';
import { faqItems } from '@/mocks/home';
import ScrollReveal from '@/components/base/ScrollReveal';
import SectionHeading from '@/components/base/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <section className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="คำถามที่พบบ่อย"
          title="คำถามที่มือใหม่ถามบ่อย"
          subtitle="รวบรวมข้อสงสัยยอดนิยมก่อนเริ่มเรียน Forex เพื่อให้คุณเริ่มต้นได้อย่างมั่นใจ"
          align="center"
        />

        <div className="mx-auto mt-12 flex max-w-3xl flex-col gap-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <ScrollReveal key={item.q} delay={index * 60}>
                <div
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? 'border-primary-300' : 'border-background-200 hover:border-background-300'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-semibold ${
                          isOpen ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-700'
                        }`}
                      >
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="text-sm font-semibold text-foreground-900 md:text-base">{item.q}</span>
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-primary-100 text-primary-700' : 'bg-background-100 text-foreground-500'
                      }`}
                    >
                      <i className={`ri-${isOpen ? 'subtract' : 'add'}-line text-base`} />
                    </span>
                  </button>

                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-2.5 px-5 pb-5 pl-[3.75rem] md:px-6 md:pl-[4.25rem]">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                        {item.a2 ? (
                          <p className="text-sm leading-relaxed text-foreground-600">{item.a2}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}